import { Role } from "enums/Role";

/** Role ranking — lower index = higher rank */
export const ROLE_RANK: Role[] = [
	Role.ADMINISTRATOR,
	Role.DANGEROUS_GOODS_AGENT,
	Role.BOOKING_AGENT,
	Role.QUICK_EDITOR
];

export function getHighestRole(roles: Role[]): Role {
	for (const rank of ROLE_RANK) {
		if (roles.includes(rank)) {
			return rank;
		}
	}
	return roles[0];
}
